"use strict";

/* global __NUCONT_SETTINGS__ */

const appSettings = __NUCONT_SETTINGS__;
export const publicSettings = appSettings.public;
export default appSettings;
